<template>
  <div id="product-reference-plugin product-reference-plugin--order">
    <ol v-if="data.length > 0" style="padding-left: 15px;">
      <li v-for="row in data" :key="row.id">
        <router-link :to="{ name: 'menu.order.detail', params: { id: row.id } }" target="_blank">{{ row.description }}, {{ row.order_number }}</router-link>
      </li>
    </ol>
    <p v-else>{{ $t('product.plugins.orders.empty') }}</p>
    <div class="text-align-right margin-top-20" v-if="product">
      <router-link target="_blank" :to="{ name: 'menu.order.new', query: { 'product_id': productId, 'type': 'single_product', 'customer_id': product.customer_id } }">
        {{ $t('product.plugins.orders.add_new_order') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'ProductOrdersPlugin',
  props: {
    product: {
      required: true
    }
  },
  data () {
    return {
      data: [],
      loading: false,
      pluginName: 'orders'
    }
  },
  computed: {
    productId: function () {
      return this.product ? this.product.id : null
    }
  },
  mounted () {
    if (this.productId) {
      this.loadPluginData(this.pluginName, this.productId)
    }
  },
  methods: {
    ...mapActions(['getProductReferencePluginData']),
    moment,
    loadPluginData (pluginName, productId) {
      this.loading = true
      this.getProductReferencePluginData({ plugin: pluginName, productId: productId }).then(resp => {
        this.data = resp.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    productId: function (newProdId, oldProdId) {
      if (newProdId !== oldProdId) {
        this.loadPluginData(this.pluginName, newProdId)
      }
    }
  }
}
</script>
